import {
  BoundingBox,
  Database,
  Gear,
  SquaresFour,
} from '@phosphor-icons/react';
import { NavItem } from './types';

export const ITEMS_WITH_EXTENDED_SIDEBAR = ['agents', 'data'] as const;

export const getNavItems = (): NavItem[] => [
  { id: 'home', icon: SquaresFour, path: '/dashboard-beta', label: 'Boards' },
  { id: 'agents', icon: BoundingBox, path: null, label: 'Agents' },
  { id: 'data', icon: Database, path: null, label: 'Data' },
  { id: 'settings', icon: Gear, path: null, label: 'Settings' },
];

export const getUserInitials = (name?: string | null): string => {
  if (!name) return 'U';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase().slice(0, 2);
  }
  return name.substring(0, 2).toUpperCase();
};
